/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

export default class ViewPortUtil {
  constructor() {}

  public static create(): ViewPortUtil {
    return new ViewPortUtil();
  }

  getViewPort(): { width: number; height: number } {
    return {
      width: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ),
      height: Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      ),
    };
  }

  isViewPortWidth(w: number, m: string) {
    const vp = this.getViewPort();
    if (m === "exact") {
      if (vp.width === w) {
        return true;
      }

      return false;
    }

    if (m === "maximum" || m === "max") {
      if (vp.width <= w) {
        return true;
      }

      return false;
    }

    if (m === "minimum" || m === "min") {
      if (vp.width >= w) {
        return true;
      }

      return false;
    }

    return true;
  }

  isViewPort(w: number, h: number, m: string) {
    const vp = this.getViewPort();
    if (m === "exact") {
      if (vp.width === w && vp.height === h) {
        return true;
      }

      return false;
    }

    if (m === "maximum" || m === "max") {
      if (vp.width <= w && vp.height <= h) {
        return true;
      }

      return false;
    }

    if (m === "minimum" || m === "min") {
      if (vp.width >= w && vp.height >= h) {
        return true;
      }

      return false;
    }

    return true;
  }
}
